import { getFeatureFlag } from 'adminPanel/api/featureFlags';
import { FeatureFlag } from 'adminPanel/types';
import { useEffect, useState } from 'react';

export const useFeatureFlag = (id: number) => {
    const [featureFlag, setFeatureFlag] = useState<FeatureFlag>();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getFeatureFlag(id)
            .then(setFeatureFlag)
            .finally(() => {
                setIsLoading(false);
            });
    }, [id]);

    const refetch = () => {
        getFeatureFlag(id)
            .then(setFeatureFlag)
            .finally(() => {
                setIsLoading(false);
            });
    };

    return { featureFlag, isLoading, refetch };
};
